import CreatorProfileForm from '../Screens/Creator/CreatorProfileForm';
import CreatorProfilePage from '../Screens/Creator/CreatorProfilePage';
import useBrandProfile from '../Hooks/useBrandProfile';

// In CreatorProfileRoute.js
export default function CreatorProfileRoute() {
    const { profile, fetchProfile } = useBrandProfile();

    const handleFormSubmit = async () => {
        await fetchProfile();
    };

    return profile
        ? <CreatorProfilePage />
        : <CreatorProfileForm onSave={handleFormSubmit} />;
}